export default "__VITE_ASSET__CIhL7bLp__"